import {
  FETCH_BANK_DETAILS_REQUEST,
  FETCH_BANK_DETAILS_SUCCESS,
  FETCH_BANK_DETAILS_FAILURE,
  CREATE_BANK_DETAILS_REQUEST,
  CREATE_BANK_DETAILS_SUCCESS,
  CREATE_BANK_DETAILS_FAILURE,
  DELETE_BANK_DETAILS_REQUEST,
  DELETE_BANK_DETAILS_SUCCESS,
  DELETE_BANK_DETAILS_FAILURE,
  UPDATE_BANK_DETAILS_REQUEST,
  UPDATE_BANK_DETAILS_SUCCESS,
  UPDATE_BANK_DETAILS_FAILURE,
} from "./types";

import {
  createBankDetails,
  fetchBankDetails,
  deleteBankDetails,
  updateBankDetails,
} from "../../services/bankDetailsService";

// Fetch
export const fetchBankDetailsRequest = () => ({ type: FETCH_BANK_DETAILS_REQUEST });
export const fetchBankDetailsSuccess = (data) => ({ type: FETCH_BANK_DETAILS_SUCCESS, payload: data });
export const fetchBankDetailsFailure = (error) => ({ type: FETCH_BANK_DETAILS_FAILURE, payload: error });

// Create
export const createBankDetailsRequest = () => ({ type: CREATE_BANK_DETAILS_REQUEST });
export const createBankDetailsSuccess = (data) => ({ type: CREATE_BANK_DETAILS_SUCCESS, payload: data });
export const createBankDetailsFailure = (error) => ({ type: CREATE_BANK_DETAILS_FAILURE, payload: error });

// Delete
export const deleteBankDetailsRequest = () => ({ type: DELETE_BANK_DETAILS_REQUEST });
export const deleteBankDetailsSuccess = (bankId) => ({ type: DELETE_BANK_DETAILS_SUCCESS, payload: bankId });
export const deleteBankDetailsFailure = (error) => ({ type: DELETE_BANK_DETAILS_FAILURE, payload: error });

// Update
export const updateBankDetailsRequest = () => ({ type: UPDATE_BANK_DETAILS_REQUEST });
export const updateBankDetailsSuccess = (data) => ({ type: UPDATE_BANK_DETAILS_SUCCESS, payload: data });
export const updateBankDetailsFailure = (error) => ({ type: UPDATE_BANK_DETAILS_FAILURE, payload: error });



// Fetch All
export const fetchBankDetailsAction = () => async (dispatch) => {
  dispatch(fetchBankDetailsRequest());
  try {
    const response = await fetchBankDetails();
    if (response.success) {
      dispatch(fetchBankDetailsSuccess(response.data));
    } else {
      dispatch(fetchBankDetailsFailure(response.error));
    }
    return response;  here
  } catch (error) {
    dispatch(fetchBankDetailsFailure(error.message));
    return { success: false, error: error.message }; // <-- return error
  }
};

// Create New
export const createBankDetailsAction =
  (bank_name, branch_name, account_number, swift_code, branch_code) =>
  async (dispatch) => {
    dispatch(createBankDetailsRequest());
    try {
      const response = await createBankDetails(bank_name, branch_name, account_number, swift_code, branch_code);
      if (response.success) {
        dispatch(createBankDetailsSuccess(response.data));
      } else {
        dispatch(createBankDetailsFailure(response.error));
      }
      return response; 
    } catch (error) {
      dispatch(createBankDetailsFailure(error.message));
      return { success: false, error: error.message }; // <-- return error
    }
  };

// Delete
export const deleteBankDetailsAction = (bankId) => async (dispatch) => {
  dispatch(deleteBankDetailsRequest());
  try {
    const response = await deleteBankDetails(bankId);
    if (response.success) {
      dispatch(deleteBankDetailsSuccess(bankId));
    } else {
      dispatch(deleteBankDetailsFailure(response.error));
    }
    return response; 
  } catch (error) {
    dispatch(deleteBankDetailsFailure(error.message));
    return { success: false, error: error.message };
  }
};

// Update
export const updateBankDetailsAction = (bankId, updates) => async (dispatch) => {
  dispatch(updateBankDetailsRequest());
  try {
    const response = await updateBankDetails(bankId, updates);
    if (response.success) {
      dispatch(updateBankDetailsSuccess(response.data));
    } else {
      dispatch(updateBankDetailsFailure(response.error));
    }
    return response; 
  } catch (error) {
    dispatch(updateBankDetailsFailure(error.message));
    return { success: false, error: error.message };
  }
};
